import { ChartData, ChartOptions } from "chart.js";

export const segmentColors = ["#5E3EA1", "#8C6BC1", "#BCA3DB", "#D5C4EB"];

export const borderRadii = [
  { topLeft: 10, bottomLeft: 10 }, // rounded start
  {}, // middle bars
  {},
  { topRight: 10, bottomRight: 10 }, // rounded end
];

export const data: ChartData<"bar"> = {
  labels: [""],
  datasets: segmentColors.map((color, index) => ({
    label: `Segment ${index + 1}`,
    data: [1],
    backgroundColor: color,
    borderRadius: borderRadii[index], // now correct type
    barThickness: 20,
    borderColor: "#fff",
    borderWidth: 2,
  })),
};

export const options: ChartOptions<"bar"> = {
  indexAxis: "y",
  responsive: true,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
  },
  scales: {
    x: { stacked: true, display: false },
    y: { stacked: true, display: false },
  },
  elements: {
    bar: {
      borderSkipped: false,
    },
  },
};

export const columns = [
  {
    title: "Username",
    dataIndex: "uploaded_by",
    key: "uploaded_by",
    sorter: (a: any, b: any) =>
      (a.uploaded_by || "").localeCompare(b.uploaded_by || ""),
  },
  {
    title: "Document Name",
    dataIndex: "document_name",
    key: "document_name",
    sorter: (a: any, b: any) => a.document_name.localeCompare(b.document_name),
  },
  {
    title: "Highlight length count",
    dataIndex: "highlight_length_count",
    key: "highlight_length_count",
    sorter: (a: any, b: any) =>
      a.highlight_length_count.localeCompare(b.highlight_length_count),
  },
];

export const highlights = [
  {
    id: 1,
    addedDate: "14/04/2025",
    username: "Arben D.",
    codesCount: 8,
    resource: "inspection_report_1.docx",
    description:
      "Initial review completed. Requires further analysis on section B and adjustments to the timeline.",
  },
  {
    id: 2,
    addedDate: "13/04/2025",
    username: "Elira M.",
    codesCount: 15,
    resource: "summary_notes_final.pdf",
    description:
      "Compiled notes from the latest field visit. Please validate the entries and confirm by end of week.",
  },
  {
    id: 3,
    addedDate: "12/04/2025",
    username: "Nertil K.",
    codesCount: 22,
    resource: "dataset_appendix.xlsx",
    description:
      "Updated dataset with new values from April submissions. Check for duplicate entries.",
  },
  {
    id: 4,
    addedDate: "11/04/2025",
    username: "Mira H.",
    codesCount: 6,
    resource: "media_summary.doc",
    description:
      "Summary of media items uploaded to the portal. Includes both images and video logs.",
  },
  {
    id: 5,
    addedDate: "10/04/2025",
    username: "Dritan S.",
    codesCount: 12,
    resource: "code_highlights_notes.txt",
    description:
      "Highlights marked for urgent review. Prioritize codes with high criticality scores.",
  },
];

export const words = [
  { text: "Word 1", value: 1 },
  { text: "Word 2", value: 2 },
  { text: "Word 3", value: 3 },
  { text: "Word 4", value: 4 },
  { text: "React", value: 2 },
  { text: "TypeScript", value: 3 },
  { text: "Frontend", value: 4 },
  { text: "Cloud", value: 3 },
  { text: "API", value: 4 },
  { text: "Ant Design", value: 2 },
  { text: "CSS", value: 3 },
  { text: "UI", value: 4 },
  { text: "Hooks", value: 2 },
  { text: "Performance", value: 3 },
  { text: "Component", value: 3 },
  { text: "State", value: 4 },
  { text: "Props", value: 3 },
  { text: "DOM", value: 2 },
  { text: "Event", value: 4 },
  { text: "Code", value: 1 },
  { text: "Layout", value: 3 },
  { text: "Style", value: 2 },
  { text: "Design", value: 3 },
  { text: "App", value: 4 },
  { text: "UI Kit", value: 2 },
];
